import { AxiosInstance } from "@bps/http-client";

import { CloudApplicationDto } from "./bp-id.dtos";
import { IBpIdGateway } from "./bp-id.gateway.interface";

export class BpIdGateway implements IBpIdGateway {
  constructor(private api: AxiosInstance) {}

  public getCloudApplications = async (): Promise<CloudApplicationDto[]> => {
    return (await this.api.get("ref/cloudApplications")).data;
  };
}
